import {
  Box,
  Button,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { useDispatch, useSelector } from "react-redux";
import FolderIcon from "@mui/icons-material/Folder";
import HouseIcon from "@mui/icons-material/House";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import GridOnIcon from "@mui/icons-material/GridOn";
import DownloadIcon from "@mui/icons-material/Download";
import CollapseSection from "../../components/ui/CollapseSection";
import DeleteIcon from "@mui/icons-material/Delete";
import StorageIcon from "@mui/icons-material/Storage";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import SharedComponent from "./SharedComponent";
import Alert from "../../components/ui/Alert";
import {
  GetUserCountries,
  GetFolderIdByName,
  GetFolderContent,
  DownloadFile,
  DeleteFile,
  UploadFile,
  ProcessFile,
  setState,
  clearStatus
} from "./fileTransferSlice";
import moment from "moment";
import muiConfig from '../../assets/MuiConfig.json'
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
export default function FileInterface() {
  const autherization = localStorage.getItem("data");
  const mydata = JSON.parse(autherization);
  let setAccess = true;
  if (mydata?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;
  const isRestrictedAccess = setAccess;
  const homeFolderName = "";
  const dispatch = useDispatch();
  var data = require("../../assets/MoveitConfig.json");
  const fileTransfer = useSelector((state) => state.fileTransfer);
  const {
    countries,
    getFolderIdByName,
    getFolderContent,
    isLoading,
    isAlert,
    isAlert_Info,
  } = fileTransfer;
  const [dataGridContent, setdataGridContent] = useState([]);
  const [breadcrumb, setBreadcrumb] = useState("");
  const [parentFolderList, setParentFolderList] = useState("");
  const [selectedFolderID, setSelectedFolderID] = useState("");
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    notfound: false,
  });
  const [isFileAvailable, setIsFileAvailable] = useState(false);
  const [fileToProcess, setFileToProcess] = useState("");
  const [parentFileID, setParentFileID] = useState("");
  const [open, setOpen] = React.useState(false);
  const [openProcessDialog, setOpenProcessDialog] = React.useState(false);
  let isCountryFolder = false;
  let sortableField = "name";
  const [isProcessButton, setIsProcessButton] = useState(false);
  const [isDeleteButton, setIsDeleteButton] = useState(false);
  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });
  const moveitDeleteConfig = data["DeleteInclude"];
  const moveitProcessConfig = data["ProcessInclude"];
  const moveitCountryFolders = data["CountryFolders"];
  const displayAlert = (showAlert, alertMessage) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: `${showAlert}`,
      alertMessage: `${alertMessage}`,
    });
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleProcessClickOpen = () => {
    setOpenProcessDialog(true);
  };
  const handleProcessClickClose = () => {
    setOpenProcessDialog(false);
  };
  useEffect(()=>{
    debugger;
    let obj = {
      method: "GET",
      id: "",
    };        
    dispatch(GetFolderContent(obj));
  
    let obj1 = {
      FolderName: "",
    };
    dispatch(GetFolderIdByName(obj1));  
  },[]);    
  useEffect(() => {
    debugger;
    // if (countries.length <= 0) {
    //   dispatch(GetUserCountries({ method: "Get" }));
    // }
    dispatch(GetUserCountries({ method: "Get" }));
    return () => {
      dispatch(setState("isAlert", false));
      dispatch(setState("isAlert_Info", ""));
      dispatch(clearStatus());
    };
  }, []);
  // useEffect(() => {
  //   let obj = {
  //     FolderName: "",
  //   };
  //   dispatch(GetFolderIdByName(obj));
  // }, [homeFolderName]);
  useEffect(() => {
    let obj = {
      method: "GET",
      id: getFolderIdByName,
    };
    setParentFolderList(getFolderIdByName);
    //dispatch(GetFolderContent(obj));
  }, [getFolderIdByName]);
  
  useEffect(() => {
    console.log("TestUseEffect", getFolderContent);
    let folderItemsArr = getFolderContent;
    if (breadcrumb == "") {
      folderItemsArr = getFolderContent.filter(
        (item) => item.name == "Inbound"
      );
    }
    if (breadcrumb == "/Inbound") {
      folderItemsArr = getFolderContent.filter(
        (item) =>
          item.name == "External Fix" ||
          item.name == "SIT" ||
          item.name == "Archive"
      );
    }
    console.log("Check Length");
    if (getFolderContent.length > 0) {
      let isFileStatusArray = getFolderContent.map(
        (item) => item.type === "File"
      );
      console.log("breadcrumb", breadcrumb);
      let isFile = isFileStatusArray.indexOf(true) > -1;
      if (
        isFile &&
        (breadcrumb.toLocaleLowerCase().includes("external fix") ||
          breadcrumb.toLocaleLowerCase().includes("sit"))
      ) {
        console.log("isFile", isFile);
        console.log(
          "external",
          breadcrumb.toLocaleLowerCase().includes("external fix")
        );
        console.log("sit", breadcrumb.toLocaleLowerCase().includes("sit"));
        setIsFileAvailable(true);
      } else {
        setIsFileAvailable(false);
      }
debugger;
      isCountryFolder = false;
      for (let i = 0; i < moveitCountryFolders.length; i++) {
        if (breadcrumb.toLowerCase() == moveitCountryFolders[i].toLowerCase()) {
          // setIsCountryFolder(true);
          isCountryFolder = true;
          break;
        }
      }
      for (let i = 0; i < moveitProcessConfig.length; i++) {
        if (breadcrumb.toLowerCase() == moveitProcessConfig[i].toLowerCase()) {
          setIsProcessButton(true);
          break;
        }
      }
      for (let i = 0; i < moveitDeleteConfig.length; i++) {
        if (breadcrumb.toLowerCase() == moveitDeleteConfig[i].toLowerCase()) {
          setIsDeleteButton(true);
          break;
        }
      }
      if (
        breadcrumb == "/Inbound/External Fix" ||
        breadcrumb == "/Inbound/SIT" ||
        breadcrumb == "/Inbound/Archive"
      ) {
        debugger;
        if (isCountryFolder) {
          debugger;
          // If folder with country folders show only required country folders
          folderItemsArr = getFolderContent.filter((item) =>
            countries.some(
              (country) =>
                country.countryName.toLowerCase() === item.name.toLowerCase()
            )
          );
        } else {
          folderItemsArr = getFolderContent;
        }
      }
      console.log("folderItemsArr", folderItemsArr);
      setdataGridContent(folderItemsArr);
    } else {
      setdataGridContent([]);
    }
  }, [getFolderContent]);
  function handleParentFolder() {
    setParentFolderList(getFolderIdByName);
    let obj = {
      method: "GET",
      id: getFolderIdByName,
    };
    dispatch(GetFolderContent(obj));
    setColumnVisibilityModel({ notfound: false });
    setBreadcrumb("");
  }
  function handleChildFolder() {
    let selectedFolderID = getFolderIdByName;
    const withoutLastBreadcrumb = breadcrumb.slice(
      0,
      breadcrumb.lastIndexOf("/")
    );
    setBreadcrumb(withoutLastBreadcrumb);
    const withoutLastId = parentFolderList.slice(
      0,
      parentFolderList.lastIndexOf(",")
    );
    setParentFolderList(withoutLastId);
    const myarray = withoutLastId.split(",");
    selectedFolderID = myarray[myarray.length - 1];
    let obj = {
      method: "GET",
      id: selectedFolderID,
    };
    dispatch(GetFolderContent(obj));
    if (selectedFolderID == getFolderIdByName) {
      setColumnVisibilityModel({ notfound: false });
    }
  }
  function setRowSelectionModel(params) {
    let id = params.row.id;
    let field = params.field;
    let type = params.row.type;
    let fileName = params.row.name;
    let parentIdToRefresh = params.row.parentId;
    setParentFileID(parentIdToRefresh);
    setFileToProcess(id);
    if (field == "name" && type == "Folder") {
      if (id) {
        const selectedRowsData = getFolderContent.find((row) => row.id === id);
        let name = breadcrumb + "/" + selectedRowsData["name"];
        let parentId = parentFolderList + "," + id;
        setBreadcrumb(name);
        setParentFolderList(parentId);
        setColumnVisibilityModel({ notfound: true });
        setSelectedFolderID(id);
        let obj = {
          method: "GET",
          id: id,
        };
        dispatch(GetFolderContent(obj));
        sortableField = "name";
      }
    }
    if (field == "path" && type == "File") {
      let obj = {
        method: "GET",
        fileId: id,
        fileName: fileName,
      };
      dispatch(DownloadFile(obj));
      sortableField = "lastUpdateTime";
    }
    // if (
    //   field == "delete" &&
    //   type == "File" &&
    //   !fileName.toLowerCase().endsWith("_template.xlsx")
    // ) {
    //   handleClickOpen();
    // }
    // if (
    //   field == "process" &&
    //   type == "File" &&
    //   !fileName.toLowerCase().endsWith("_template.xlsx")
    // ) {
    //   handleProcessClickOpen();
    // }
  }
  function handleDeleteFile() {
    handleClose();
    let obj = {
      fileId: fileToProcess,
    };
    dispatch(DeleteFile(obj))
      .then(() => GetFolderContentAfterProcessing(selectedFolderID));
  }
  function handleProcessFile() {
    handleProcessClickClose();
    let obj = {
      fileId: fileToProcess,
      filePath: breadcrumb,
    };
    dispatch(ProcessFile(obj))
      .then(() => GetFolderContentAfterProcessing(selectedFolderID));
  }
  function GetFolderContentAfterProcessing(fileId) {
    let obj = {
      method: "GET",
      id: fileId,
    };
    dispatch(GetFolderContent(obj));
    sortableField = "lastUpdateTime";
  }
  const handleFileUpload = (event) => {
    const fileObj = event.target.files[0];
    for (let i = 0; i < getFolderContent.length; i++) {
      if (getFolderContent[i].name == fileObj.name) {
        displayAlert(true, "File already exists");
        return;
      }
    }
    var today = new Date();
    var thisYear = today.getFullYear();
    var thisMonth = ("0" + (today.getMonth() + 1)).slice(-2);
    var thisDay = ("0" + today.getDate()).slice(-2);
    var now =
      today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds();
    let fileName =
      fileObj.name.replace(/\.[^/.]+$/, "") +
      "_" +
      thisYear +
      thisMonth +
      thisDay +
      "_" +
      now;
    let fileExtension = fileObj.name.split(".").pop();
    var obj = {
      filePath: breadcrumb,
      folderId: selectedFolderID,
      fileExtension: fileExtension,
      fileName: fileName,
      type: fileObj.type,
      fileObj: fileObj,
    };
    dispatch(UploadFile(obj))
      .then(() => GetFolderContentAfterProcessing(selectedFolderID));
    event.target.value = "";
    event.target.files = null;
  };
  function DisplayAlertMessage() {
    if (isAlert) displayAlert(true, isAlert_Info);
  }
  const columns = [
    {
      field: "notfound",
      sortable: false,
      renderHeader: () => (
        <div>
          <HouseIcon
            fontSize="large"
            onClick={handleParentFolder}
            sx={{ color: "darkred.light", cursor: "pointer" }}
          />
          <KeyboardReturnIcon
            fontSize="large"
            onClick={handleChildFolder}
            sx={{
              color: "darkred.light",
              cursor: "pointer",
              transform: "rotate(90deg)",
            }}
          />
        </div>
      ),
      flex: 1.5,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 4,
      renderCell: (params) => {
        let name = params.row.name;
        if (params.row.type == "Folder") {
          return (
            <div style={{ cursor: "pointer" }}>
              <FolderIcon
                sx={{
                  color: "#f8d775",
                  cursor: "pointer",
                  transform: "translate(0px, 5px)",
                  mr: 1,
                }}
                className="folderIcon"
              />
              <span className="spanCursor">{params.row.name}</span>
            </div>
          );
        } else {
          if (name.includes(".zip")) {
            return (
              <div>
                <InsertDriveFileIcon sx={{ color: "green.main" }} />
                <span>{params.row.name}</span>
              </div>
            );
          } else if (name.includes(".xls")) {
            return (
              <div>
                <GridOnIcon sx={{ color: "green.main" }} />
                <span>{params.row.name}</span>
              </div>
            );
          } else {
            <span>{params.row.name}</span>;
          }
        }
      },
    },
    {
      field: "lastUpdateTime",
      headerName: "Last Modified on",
      flex: 2,
      renderCell: (params) => {
        let lastUpdateTime = new Date(params.row.lastUpdateTime);
        lastUpdateTime = moment(lastUpdateTime).format("DD/MM/yyyy, h:mm:ss A");
        if (params.row.type == "File") {
          return <span>{lastUpdateTime}</span>;
        } else return <span></span>;
      },
      clickable: false,
    },
    {
      field: "size",
      headerName: "Size",
      flex: 1,
      renderCell: (params) => {
        if (params.row.type == "File") {
          return <span>{params.row.size}</span>;
        } else return <span></span>;
      },
      clickable: false,
      sortable: false,
    },
    {
      field: "path",
      headerName: "Download",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        if (params.row.type == "File") {
          return (
            <div>
              <DownloadIcon sx={{ cursor: "pointer", color: "green.main" }} />
            </div>
          );
        } else return <span></span>;
      },
      clickable: false,
      sortable: false,
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        if (
          params.row.type == "File" &&
          !params.row.name.toLowerCase().endsWith("_template.xlsx") &&
          //isDeleteButton &&
          isFileAvailable &&
          isRestrictedAccess
        ) {
          return (
            <div>
              <DeleteIcon
                sx={{ color: "red.main", cursor: "pointer" }}
                onClick={handleClickOpen}
              />
            </div>
          );
        } else return <span></span>;
      },
      clickable: false,
      sortable: false,
    },
    {
      field: "process",
      headerName: "Process",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        if (
          params.row.type == "File" &&
          !params.row.name.toLowerCase().endsWith("_template.xlsx") &&
          //isProcessButton &&
          isFileAvailable &&
          isRestrictedAccess
        ) {
          return (
            <div>
              <StorageIcon
                sx={{ color: "rgb(98, 0, 255)", cursor: "pointer" }}
                onClick={handleProcessClickOpen}
              />
            </div>
          );
        } else return <span></span>;
      },
      clickable: false,
      sortable: false,
    },
  ];
  return (
    <CollapseSection title="File Upload & Download">
      <Box mt={4}>
        <Box mt={2}>
          <h5 sx={{ color: "007dc3" }}>Path:{breadcrumb}</h5>
        </Box>
        {isFileAvailable && (
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            disabled={!isRestrictedAccess}
            onChangeCapture={handleFileUpload}
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              "&:hover": {
                bgcolor: "darkred.main",
              },
            }}
          >
            Upload file
            <VisuallyHiddenInput
              type="file"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            />
          </Button>
        )}
        {alert.alertDisplay && (
          <Alert message={alert.alertMessage} severity={alert.alertSeverity} />
        )}
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress />
        </Backdrop>
        <SharedComponent />
        <Box mt={2} sx={{ width: "100%" }}>
          <DataGridPro
            disableColumnMenu
            rows={dataGridContent || []}
            columns={columns}
            sx={{
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "grey.lighter",
                color: "darkred.light",
                fontWeight: "bold",
                fontSize: "16px",
                height: "50px",
                lineHeight: "50px",
                border: "1px solid #c6c6c6",
              },
            }}
            getRowId={(row) => row?.id}
            initialState={{
              filter: {
                filterModel: {
                  items: ["name"],
                  quickFilterValues: [],
                },
              },
              sorting: {
                sortModel: [{ field: { sortableField }, sort: "desc" }],
              },
              pagination: { paginationModel: { pageSize:20, page:0 }}
            }}
            pagination
            pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]} 
            onCellClick={setRowSelectionModel}
            columnVisibilityModel={columnVisibilityModel}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: isFileAvailable,
                quickFilterProps: {
                  variant: "outlined",
                  size: "small",
                },
                printOptions: { disableToolbarButton: true },
                csvOptions: { disableToolbarButton: true },
              },
            }}
          />
        </Box>
      </Box>
      <Dialog
        open={open}
         onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to delete the file?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
                      sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        textTransform: "none",
                        fontWeight: "bold",
                        "&:hover": {
                          bgcolor: "darkred.main",
                        },
                      }}  
          onClick={handleClose}>No</Button>
          <Button 
                      sx={{
                        bgcolor: "darkred.light",
                        color: "white.main",
                        textTransform: "none",
                        fontWeight: "bold",
                        "&:hover": {
                          bgcolor: "darkred.main",
                        },
                      }}  
          onClick={handleDeleteFile} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openProcessDialog}
        onClose={handleProcessClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to process the file?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              "&:hover": {
                bgcolor: "darkred.main",
              },
            }}          
          onClick={handleProcessClickClose}>No</Button>
          <Button 
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              "&:hover": {
                bgcolor: "darkred.main",
              },
            }}          
          onClick={handleProcessFile} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </CollapseSection>
  );
}